import styled, { css } from 'styled-components';
import media from 'client/styles/media';

const columnPadding = '20px';
const columnPaddingSmall = '20px';

const columnPaddedMixin = css`
  padding-left: ${columnPaddingSmall};
  padding-right: ${columnPaddingSmall};

  ${media.sm} {
    padding-left: ${columnPadding};
    padding-right: ${columnPadding};
  }
`;

const columnUnPaddedMixin = css`
  margin-left: -${columnPaddingSmall};
  margin-right: -${columnPaddingSmall};

  ${media.sm} {
    margin-left: -${columnPadding};
    margin-right: -${columnPadding};
  }
`;

const PageColumn = styled.div<{ fullWidth?: boolean }>`
  padding-top: 0px;
  padding-bottom: 60px;

  overflow-x: hidden;

  ${columnPaddedMixin}

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}


  /* header height is 52px
  we remove extra 60px + 44px because of mobile devices
  with their address bars and UI elements */
  min-height: calc(100vh - 156px);
  ${media.sm} {
    min-height: calc(100vh - 120px);
  }
`;

const PageUnColumn = styled.div`
  ${columnUnPaddedMixin}
`;

export { PageColumn, PageUnColumn, columnPaddingSmall };
